import { Button } from "@material-ui/core";
import React from "react"


function FormActionButtons(props){

    const {cancelFunction, submitFunction, cancelText = "Cancelar", submitText= "Aceptar", disabled, disableSubmit} = props;


    return(
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <Button
            disabled={disabled}
            variant="outlined"
            color="primary"
            onClick={ () => cancelFunction()}
        >
        {cancelText}    
        </Button>
        <Button
            disabled={disabled || disableSubmit}
            variant="contained"
            color="primary"
            onClick={()=> submitFunction()}
            text={submitText}
        >
        {submitText}
        </Button>
    </div> 
    )
}

export {FormActionButtons}